import { render, staticRenderFns } from "./ContactPopup.vue?vue&type=template&id=89841ede&"
import script from "./ContactPopup.vue?vue&type=script&lang=js&"
export * from "./ContactPopup.vue?vue&type=script&lang=js&"
import style0 from "./ContactPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports